<template>
  <Popover ref="notesPopover" :showHeader="true" headerTitle="Notes">
    <div class="order-item-popover-content">
      <FormInputTextArea ref="notesEntry" :value="value" @input="$emit('update', $event)" placeholder="Item Notes" />
    </div>
  </Popover>
</template>


<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'

export default {
  name: 'OrderItemNotesPopover',
  model: {
    event: 'update'
  },
  components: {
    Popover
  },
  props: {
    value: [String, Number]
  },
  methods: {
    displayFromElement(element) {
      this.$refs.notesPopover.displayFromElement(element)

      this.$nextTick(() => {
        this.$refs.notesEntry.focus({ preventScroll: true  })
      })
    }
  }
}
</script>